import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { paymentFormLegacyDefaultV0Schema } from './default';
import { paymentFormLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch.
 *
 * Like the form widget, the variants diverge only on `position`: the default
 * branch carries the simple per-device grid, the zero branch requires the
 * extended-position grid.
 */
const paymentFormLegacyEntityUnion = z.discriminatedUnion('type', [
    paymentFormLegacyDefaultV0Schema,
    paymentFormLegacyZeroV0Schema,
]);

export type LegacyPaymentFormDefault = z.infer<typeof paymentFormLegacyDefaultV0Schema>;
export type LegacyPaymentFormZero = z.infer<typeof paymentFormLegacyZeroV0Schema>;
export type LegacyPaymentFormWidget = LegacyPaymentFormDefault | LegacyPaymentFormZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0
 * redesign yet). Single 'web' variant today; its data schema normalises old
 * forms on load (see `paymentFormLegacyDefaultDataSchema`).
 */
export const LegacyPaymentFormWidgetEntitySchema = createLegacyEntitySchema([
    { name: 'web', schema: paymentFormLegacyEntityUnion },
]);
